export default __webpack_public_path__ + "static/media/terock.ce427c6c.png";